import { __decorate, __metadata } from "tslib";
import { IsUndefinable, PromotionAmountTypeEnum, PromotionDiscountBehaviourEnum, PromotionDiscountLevelEnum } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsInt, IsNumber, IsOptional, IsPositive } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { PromotionExternalAmountTypeEnum } from '../enum';
import { OrderExposeGroup } from '../interface';
export class PatchOrderPromotionDiscountDto {
}
__decorate([
    ApiPropertyOptional({ enum: PromotionDiscountLevelEnum, example: PromotionDiscountLevelEnum.COMBO }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(PromotionDiscountLevelEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPromotionDiscountDto.prototype, "level", void 0);
__decorate([
    ApiPropertyOptional({ enum: PromotionAmountTypeEnum, example: PromotionAmountTypeEnum.FIXED }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(PromotionAmountTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPromotionDiscountDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ enum: PromotionExternalAmountTypeEnum, example: PromotionExternalAmountTypeEnum.OPEN }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(PromotionExternalAmountTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPromotionDiscountDto.prototype, "externalType", void 0);
__decorate([
    ApiPropertyOptional({ enum: PromotionDiscountBehaviourEnum, example: PromotionDiscountBehaviourEnum.ADD_ITEM }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(PromotionDiscountBehaviourEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderPromotionDiscountDto.prototype, "behavior", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'original amount (for both, fixed & percent discounts)', example: 0.05 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchOrderPromotionDiscountDto.prototype, "amount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], PatchOrderPromotionDiscountDto.prototype, "appliesToModifiers", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 0 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchOrderPromotionDiscountDto.prototype, "maxAmount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], PatchOrderPromotionDiscountDto.prototype, "isCumulative", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Number,
        description: 'If set, there must be at least this many items from promotion targets in a cart for the discount to apply.',
        minimum: 1,
        example: 5,
    }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsPositive({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], PatchOrderPromotionDiscountDto.prototype, "quantityMin", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Number,
        description: 'If set, there must be exactly this many items from promotion targets in the cart for the discount to apply.',
        minimum: 1,
        example: 5,
    }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsPositive({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], PatchOrderPromotionDiscountDto.prototype, "quantityExact", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Number,
        description: 'If set, the discount will be applied to a maximum of this many items from promotion targets.',
        minimum: 1,
        example: 5,
    }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsPositive({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], PatchOrderPromotionDiscountDto.prototype, "quantityMax", void 0);
//# sourceMappingURL=PatchOrderPromotionDiscountDto.js.map